export default "__VITE_ASSET__BiSlGYRG__"